import { render, staticRenderFns } from "./PlanificationUserAddOrUpdate.vue?vue&type=template&id=2efa1da2&"
import script from "./PlanificationUserAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./PlanificationUserAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports